// src/publish/fileName.js — the stem of every downloaded file.
//
//   entryFileStem(entry) → "<platform>-<contentFormat>_<slug of topic>_<YYYY-MM-DD>"
//   e.g. "blog-seo_come-ridurre-il-time-to-market-nel-b2b-c_2026-10-06"
//
// The slug is ASCII only (accents stripped, anything else a hyphen), lower
// case, at most 40 characters, never ending in a hyphen; an empty topic gives
// "output". The format part falls back to entry.mode, the date to today when
// the entry carries no timestamp. The extension is the caller's.

const MAX_SLUG = 40;

/** "Perché un lancio B2B?" → "perche-un-lancio-b2b" (max 40 chars, 'output' when empty). */
export function slugify(value, max = MAX_SLUG) {
  const s = String(value ?? '')
    .normalize('NFKD')
    .replace(/\p{M}/gu, '')
    .replace(/[^A-Za-z0-9]+/g, '-')
    .toLowerCase()
    .replace(/^-+|-+$/g, '');
  const cut = s.slice(0, max).replace(/-+$/g, '');
  return cut || 'output';
}

/** YYYY-MM-DD of a Date or parseable string in local time; today when missing or invalid. */
export function isoDate(value) {
  let d = value instanceof Date ? value : value ? new Date(value) : new Date();
  if (Number.isNaN(d.getTime())) d = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** The format part: "<platform>-<contentFormat>", else entry.mode, else "output". */
export function entryFormatSlug(entry) {
  const r = entry?.results || {};
  const parts = [r.platform, r.contentFormat].filter((p) => typeof p === 'string' && p.trim());
  if (parts.length) return slugify(parts.join('-'));
  return slugify(entry?.mode);
}

export function entryFileStem(entry) {
  const topic = entry?.results?.topic || entry?.params?.topic || '';
  return `${entryFormatSlug(entry)}_${slugify(topic)}_${isoDate(entry?.timestamp)}`;
}
